import React, { useEffect, useState } from "react";
import CustomDrawer from "../../../../common/custom-drawer/custom-drawer";
import styles from "./add-edit-new-holiday.module.css";
import CustomButton from "../../../../common/custom-button/custom-button";
import CustomTextfield from "../../../../common/input/custom-textfield/custom-textfield";
import { Col, Row, Select } from "antd";
import { Controller, useForm } from "react-hook-form";
import CustomDatepicker from "../../../../common/input/custom-datepicker/custom-datepicker";
import CustomSelect from "../../../../common/input/custom-select/custom-select";
import { DATE_FORMAT, holidayTypeList } from "../../../../constants/common";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import { createHoliday, editHoliday } from "../../../../services/holiday_leave";
import { toast } from "react-toastify";
import { validateDate } from "../../../../utils/format-date/format-date";

const AddEditNewHoliday = ({ open, onClose, data = {}, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const { control, getValues, reset, trigger } = useForm({
    mode: "onChange",
    defaultValues: {
      reason: "",
      date: "",
      type: "",
      description: "",
    },
  });

  useEffect(() => {
    if (open) {
      if (data?.id) {
        reset({
          reason: data?.reason,
          date: validateDate(data?.date, DATE_FORMAT.YYYY_MM_DD),
          type: data?.type,
          description: data?.description,
        });
      } else {
        reset({
          reason: "",
          date: "",
          type: "",
          description: "",
        });
      }
    }
  }, [data, open]);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const isValid = await trigger();
      if (!isValid) {
        return;
      }
      const formValues = getValues();
      const payload = {
        reason: formValues?.reason,
        date: dayjs(formValues?.date).format(DATE_FORMAT.YYYY_MM_DD),
        type: formValues?.type,
        description: formValues?.description,
      };
      if (data?.id) await editHoliday(data?.id, payload);
      else await createHoliday(payload);
      toast.success(`Holiday ${data?.id ? "edited" : "created"} successfully!`);
      onSuccess();
      handleClose();
    } catch (err) {
      toast.error(
        err?.data?.message ||
          `Failed to ${data?.id ? "edit" : "create"} holiday`
      );
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    reset({
      reason: "",
      date: "",
      type: "",
      description: "",
    });
    onClose();
  };

  return (
    <CustomDrawer
      title={`${data?.id ? "Edit" : "Create"} New Holiday`}
      open={open}
      onClose={handleClose}
      className={styles.drawer}
      footer={
        <div className={styles.footerWrapper}>
          <CustomButton
            onClick={handleClose}
            title="Back"
            variant="outlined"
            className={styles.footerBackButton}
            disabled={loading}
          />
          <CustomButton
            title={`${data?.id ? "Edit" : "Create"} Holiday`}
            size="large"
            onClick={handleSubmit}
            loading={loading}
          />
        </div>
      }
      width="40vw"
      drawerStyles={{ body: { padding: "50px" } }}
    >
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <Controller
            name="reason"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <CustomTextfield
                id="reason"
                label="Holiday Name"
                showRequired
                labelColor="#171717"
                placeholder="Enter holiday Year"
                size="large"
                type="text"
                value={value}
                onChange={onChange}
                status={error ? "error" : ""}
              />
            )}
          />
        </Col>
        <Col span={24}>
          <Controller
            name="date"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <CustomDatepicker
                id="date"
                label="Date"
                showRequired
                labelColor="#171717"
                placeholder="DD-MM-YY"
                size="large"
                allowClear={false}
                value={value}
                onChange={onChange}
                style={{ height: "40px", width: "100%" }}
                status={error ? "error" : ""}
                prefix={
                  <img
                    src="/assets/images/calendarOutlined.svg"
                    style={{ marginRight: 4 }}
                    alt="calendar"
                  />
                }
              />
            )}
          />
        </Col>
        <Col span={24}>
          <Controller
            name="type"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <CustomSelect
                id="type"
                label="Select Holiday Type"
                showRequired
                labelColor="#171717"
                placeholder="--Select--"
                size="large"
                value={value}
                onChange={onChange}
                status={error ? "error" : ""}
              >
                {holidayTypeList?.map((item, index) => (
                  <Select.Option key={index} value={item?.value}>
                    {item?.label}
                  </Select.Option>
                ))}
              </CustomSelect>
            )}
          />
        </Col>
        <Col span={24}>
          <Controller
            name="description"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <div>
                Description (Optional)
                <TextArea
                  style={{ marginTop: "10px" }}
                  id="description"
                  label="Description"
                  placeholder="Type description here"
                  size="large"
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                  rows={4}
                />
              </div>
            )}
          />
        </Col>
      </Row>
    </CustomDrawer>
  );
};

export default AddEditNewHoliday;
